import React, { useEffect } from "react";
import { Route, Redirect, HashRouter, Switch, useLocation } from "react-router-dom";
import cookie from 'react-cookies';

import Exercises from "./containers/exercises";
import Home from "./containers/home/home";
import BlockPage from "./containers/lessons/blockPage";
import { EmbeddableCoursePage } from "./containers/embeddable/EmbeddableCoursePage";
import { AppGlobalConfigProvider } from "./providers/AppGlobalConfigContext";
import { EmbeddableExercisesPage } from "./containers/embeddable/EmbeddableExercisesPage";
import FullPageLogin from "./components/FullPageLoader";
import AuthCallback from "./service/auth_callback";
// import AuthGuard from "./service/auth_guard";
import ErrorPage from "./components/ErrorPage";
import NewLogin from "./components/new_login";

const checkLoginStatus = () => {
    const token = cookie.load('token_info');
    const userInfo = JSON.parse(localStorage.getItem("user-info") || "{}");
    return token && userInfo.id;
};

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props =>
        checkLoginStatus() ? (
            <Component {...props} />
        ) : (
            <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
    }
    />
);

const sendDataLayer = () => {
    const user = JSON.parse(localStorage.getItem('user-info') || "{}");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'userId': user.id });
};

const LoginCallbackRoute = (props) => {
  const location = useLocation();
  const path = location.hash ? location.hash.replace("#", "") : "";

  console.log("LoginCallbackRoute location:", location);

  return path.startsWith("/login_callback") ? (
    <React.StrictMode>
      <AuthCallback {...props} />
    </React.StrictMode>
  ) : (
    <Redirect to="/" />
  );
};

function App() {
    useEffect(() => {
        sendDataLayer();
    }, []);

    return (
        <div className="App">
            <HashRouter basename="catchup">
                <AppGlobalConfigProvider>
                        <Switch>
                            <Route exact path="/" render={(props) => (
                                checkLoginStatus() ? <Redirect to="/classes/list" /> : <NewLogin />
                            )} />

                            <Route path="/login_callback" component={AuthCallback} />


                            <PrivateRoute path="/classes/list" component={Home} />
                            <Route exact path="/login_catchup" render={() => <Redirect to="/" />} />
                            <PrivateRoute path="/protected" component={() => <h1> Protected </h1>} />
                            <PrivateRoute path="/catchupId/:catchupId/lesson/:lessonId/:block" component={Exercises} />
                            <PrivateRoute path="/lessonsList" component={BlockPage} />
                            <Route path="/embeddable/home/:jwt" component={EmbeddableCoursePage} />
                            <Route path="/embeddable/lesson/:jwt" component={EmbeddableExercisesPage} />
                            <Route path="/embeddable/catchupId/:catchupId/lesson/:lessonId/:block" component={Exercises} />
                            <Route path="/embeddable/lessonsList" component={BlockPage} />
                            <Route path="/embeddable/classes/list" component={Home} />
                            <Route path="/error_page" component={ErrorPage} />
                            <Route path="/new_login" component={NewLogin} />
                        </Switch>
                </AppGlobalConfigProvider>
            </HashRouter>
        </div>
    );
}

export default App;